export enum PlanTypes {
    DAY = 'day',
    MONTH = 'month',
    YEAR = 'year',
};

export enum DatePickerOptions {
    SELECTDATE = 'selectDate',
    STARTDATE = 'startDate',
    ENDDATE = 'endDate',
};

export enum OptionTypes {
    ADD = 'add',
    EDIT = 'edit',
    DEFAULT = ''
};

export enum TimePickerOptions {
    MINUTE = 'minute',
    HOUR = 'hour',
    MONTH = 'month',
    YEAR = 'year',
};

export enum NavigationOptions {
    PREVIOUS = "previous",
    NEXT = "next",
};

export enum ScreenSizes {
    MOBILE = 900,
};

export enum WelcomePageDesktopActiveTypes {
    SIGNIN = '',
    SIGNUP = 'right-panel-active',
};

export enum AccountFormTypes {
    CREATE = 'create',
    LOGIN = 'login'
};

export enum DesktopDisplayOptions {
    HOME = 'home',
    PROFILE = 'profile',
    HELP = 'help',
    SETTINGS = 'settings',
};

export enum ApplicationThemeOptions {
    DARK = 'darktheme',
    LIGHT = 'lighttheme',
};

export enum ApplicationThemesColours {
    DARK = '#707070',
    LIGHT = '#fff',
};